<template>
  <a-modal
    title="添加阶段"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="添加"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增阶段</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="stageNumberTitle">
        <i class="toRequired">*</i>序号
      </span>
      <span slot="stageCodeTitle">
        <i class="toRequired">*</i>阶段名称
      </span>
      <span slot="necessaryFlagTitle">
        <i class="toRequired">*</i>必须步骤
      </span>
      <!-- <span slot="nextStepFlagTitle">
        <i class="toRequired">*</i>自动执行下一步
      </span> -->
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'" class="table-line">
            <a @click="handleDelete(tableList, record)">删除</a>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              @change="(val, list) => selectChange(val, list, record, item.dataIndex)"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="1" />
          </span>
          <span v-else-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiScpMrpPlanStagesAdd } from '@/api/scp/planSetting/mrpPlanName'

export default {
  props: {
    stageCodeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '序号',
          width: 160,
          dataIndex: 'stageNumber',
          scopedSlots: { customRender: 'stageNumber', title: "stageNumberTitle" },
          type: "inputNumber"
        },
        {
          // title: '阶段名称',
          width: 160,
          dataIndex: 'stageCode',
          scopedSlots: { customRender: 'stageCode', title: "stageCodeTitle" },
          type: "select",
          dataList: 'stageCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '说明',
          width: 160,
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          type: "input",
          disabled: true
        },
        {
          // title: '必须步骤',
          width: 140,
          dataIndex: 'necessaryFlag',
          scopedSlots: { customRender: 'necessaryFlag', title: "necessaryFlagTitle" },
          type: "switch"
        },
        // {
        //   // title: '自动执行下一步',
        //   width: 140,
        //   dataIndex: 'nextStepFlag',
        //   scopedSlots: { customRender: 'nextStepFlag', title: "nextStepFlagTitle" },
        //   type: "switch"
        // },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: [],
      detail: null
    }
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (detail) {
      this.detail = detail
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        stageNumber: "",
        stageCode: "",
        remark: "",
        necessaryFlag: "Y",
        // nextStepFlag: "Y",
        message: "",
        planName: this.detail.planName,
        enableFlag: "Y",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].stageNumber || !this.tableList[i].stageCode) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiScpMrpPlanStagesAdd(this.tableList).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.tableList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.tableList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    selectChange (val, list, record, dataIndex) {
      if (dataIndex === "stageCode") {
        record.remark = this.$getFlagName(list, val, "lookupCode", "remark")
      }
    },
    setArray (arr) {
      return this[arr]
    },
    statusTableOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 140px;
}
input{
  width: 140px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: -420px;
    bottom: -30px;
    z-index: 10000000;
  }
}
</style>
